import HomeUpdateSpecifiedItemsWrapper from './HomeUpdateSpecifiedItemsWrapper';

export default HomeUpdateSpecifiedItemsWrapper;



